import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { richText } from '../../util/richText';

import css from './ListingPage.module.css';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

/**
 * Renders About, What I can help with, or Topics I Cover sections.
 * Uses the same body text style for consistency across all three.
 * With the bold prop, **some text** in the text is rendered as bold.
 */
const SectionTextMaybe = props => {
  const { text, heading, kickerId, topics = null, publicData = {}, bold = false } = props;

  const content = text
    ? richText(text, {
        linkify: true,
        bold,
        longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
        longWordClass: css.longWord,
        breakChars: '/',
      })
    : null;

  const topicsList = topics || publicData.topics || publicData.topicsICover;
  const hasTopics = Array.isArray(topicsList) && topicsList.length > 0;

  const hasContent = content || hasTopics;
  if (!hasContent) return null;

  return (
    <section className={css.sectionTextBlock}>
      {kickerId ? (
        <div className={css.sectionKicker}>
          <FormattedMessage id={kickerId} />
        </div>
      ) : null}
      {heading ? <h2 className={css.sectionHeading}>{heading}</h2> : null}
      {content ? <div className={css.sectionTextBody}>{content}</div> : null}
      {hasTopics ? (
        <ul className={css.topicsList}>
          {topicsList.map((topic, idx) => (
            <li key={idx} className={css.topicItem}>
              {topic}
            </li>
          ))}
        </ul>
      ) : null}
    </section>
  );
};

export default SectionTextMaybe;
